import { defineComponent as _defineComponent } from 'vue'
import CheckoutApi from '@/services/api/CheckoutApi'
  import { computed, ref, watch, nextTick } from 'vue'
  import { AxiosError } from 'axios'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
  import { UserModule } from '@/store/modules/user'
  import type { Coupon as ICoupon } from '@/services/interfaces/Checkout'
  import type { Nullable } from '@/services/interfaces/Content'
  import type { PropType } from 'vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Coupon',
  props: {
    value: {
      type: String,
      default: '',
    },
    courseProductTitle: {
      type: String,
      required: true,
    },
    courseFeedbackEmails: {
      type: Array as PropType<string[]>,
      required: true,
    },
  },
  emits: ['input'],
  setup(__props, { expose, emit }) {

const props = __props;

  

  

  const isApplyingCoupon = ref(false)
  const isShowingCouponBox = ref(false)
  const couponResponse = ref(null as Nullable<ICoupon>)
  const canUseAnyCode = ref(true)

  const couponInput = ref(null as HTMLInputElement | null)

  expose({ couponResponse })
  const showCouponInput = () => {
    isShowingCouponBox.value = true
    nextTick(() => {
      couponInput.value!.focus()
    })
  }

  const couponModel = computed({
    get(): string {
      return props.value
    },
    set(value: string) {
      emit('input', value)
    },
  })

  const couponValue = computed(() => {
    if (couponResponse.value?.percentOff) return Math.round(couponResponse.value.percentOff * 100)
    return couponResponse.value?.amountOff || 0
  })

  const referrerCode = computed(() => UserModule.userReferralCode)

  watch(couponModel, () => {
    nextTick(() => {
      canUseAnyCode.value = true
    })
  })

  const applyCouponCode = () => {
    if (referrerCode.value === props.value) {
      canUseAnyCode.value = false
      return
    }
    isApplyingCoupon.value = true
    couponResponse.value = null
    let transformedCode = props.value
    if (props.value?.startsWith('FRIEND-')) {
      transformedCode = props.value?.split('FRIEND-')[1]
    }
    CheckoutApi.couponDetails(transformedCode)
      .then((coupon) => {
        couponResponse.value = coupon
      })
      .catch((err: AxiosError) => {
        couponResponse.value = { ...((err.response?.data as any) || {}) }
      })
      .finally(() => {
        isApplyingCoupon.value = false
      })
  }

return { __sfc: true,emit, props, isApplyingCoupon, isShowingCouponBox, couponResponse, canUseAnyCode, couponInput, showCouponInput, couponModel, couponValue, referrerCode, applyCouponCode, CheckoutApi, computed, ref, watch, nextTick, AxiosError, LoadingSpinner, UserModule }
}

})